$(() => {
  const viewAllCommunities = $('#view-all-communities');
  const communitiesModal = $('#communities-modal');

  viewAllCommunities.click(() => {
    communitiesModal.removeClass('hidden');
    $('body').css('overflow', 'hidden');
  });
});
